var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagneticStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.415 0.292h-15.831c-0.88 0-1.585 0.724-1.585 1.615v8.247h17.75c0.165-0.005 0.334 0 0.489 0.058 0.442 0.152 0.761 0.577 0.761 1.080v-9.385c0-0.891-0.71-1.615-1.585-1.615zM22.41 7.821h-15.826v-5.715c0-0.11 0.087-0.199 0.196-0.199h15.435c0.108 0 0.195 0.089 0.195 0.199v5.715zM22.669 11.506h-21.262c-0.778 0-1.406 0.628-1.406 1.406v7.664h24v-7.739c-0.042-0.717-0.614-1.294-1.331-1.331zM0.469 23.708c-0.258 0-0.469-0.211-0.469-0.469v-1.641h24v1.641c0 0.258-0.211 0.469-0.469 0.469h-23.062zM19.978 3.823h-2.081c-0.192 0-0.347 0.155-0.347 0.347v1.158c0 0.192 0.155 0.347 0.347 0.347h2.081c0.192 0 0.347-0.155 0.347-0.347v-1.158c0-0.188-0.159-0.347-0.347-0.347zM12.347 3.823h3.928c0.192 0 0.347 0.159 0.347 0.347v1.158c0 0.192-0.155 0.347-0.347 0.347h-3.928c-0.192 0-0.347-0.155-0.347-0.347v-1.158c0-0.192 0.155-0.347 0.347-0.347z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagneticStripe);
export default __webpack_public_path__ + "static/media/magnetic-stripe.8e344c35d158f3ed1b07ae2384f6f82f.svg";
export { ForwardRef as ReactComponent };